import { Availability } from '../../domain/Availability'
import { BookingReason } from '../../domain/BookingReason'
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { NGBDateTimeAdapter } from '../../utilities/NgbDateTimeAdapter'
import { NgbDate, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap'

@Component({
    selector: 'app-duration-options',
    templateUrl: './duration-options.component.html',
})
export class DurationOptionsComponent implements OnChanges {

    @Input() availability!: Availability
    @Input() form!: FormGroup
    @Input() isLoading!: boolean
    @Output() durationSelected = new EventEmitter<BookingReason>()
    durationOptions: { reason: BookingReason; isUnavailable: boolean }[] = []
    selectedDuration: BookingReason | null = null
    showValidationError = false
    private ngbDateAdapter = new NgbDateNativeAdapter()
    private ngbTimeAdapter = new NGBDateTimeAdapter()

    ngOnChanges(changes: SimpleChanges) {
        if (!this.availability || !this.form) {
            return
        }
        const selectedReasonId = this.form.get('selectedReasonId')?.value as string | null
        this.selectedDuration = selectedReasonId
            ? this.availability.venue.reasonWithId(selectedReasonId)
            : null
        this.updateDurationOptions()
    }

    next() {
        if (this.selectedDuration) {
            this.form.get('selectedReasonId')?.setValue(this.selectedDuration.id)
            this.form.get('selectedReasonId')?.markAsDirty()
            this.durationSelected.emit(this.selectedDuration)
        } else {
            this.showValidationError = true
        }
    }

    onDurationSelected(reason: BookingReason, isUnavailable: boolean) {
        if (isUnavailable) {
            return
        }
        this.selectedDuration = reason
        this.showValidationError = false
    }

    get hasAvailableDurations(): boolean {
        return this.durationOptions.some(option => !option.isUnavailable)
    }

    get selectedSlotTime(): Date | null {
        return this.selectedBookingSlotDateTime()
    }

    private updateDurationOptions() {
        const selectedDateTime = this.selectedBookingSlotDateTime()
        if (!selectedDateTime) {
            this.durationOptions = []
            return
        }
        const partySize = this.form.get('partySize')?.value as number
        const eventId = this.form.get('selectedEventId')?.value as string | null
        const selectedAreaId = this.form.get('selectedAreaId')?.value as string | null
        const reasons = this.availability.venue.reasonsUsedOnDate(selectedDateTime)
        this.durationOptions = reasons.map(reason => {
            const isUnavailable = selectedAreaId !== null
                ? this.availability.reservableOptionWithConfiguration(
                    selectedAreaId,
                    partySize,
                    reason.id,
                    eventId,
                    selectedDateTime
                ) === null
                : !this.availability.hasReservableReasonOptionAtDateTime(
                    reason.id,
                    partySize,
                    eventId,
                    selectedDateTime
                )
            return {
                reason,
                isUnavailable,
            }
        })
    }

    private selectedBookingSlotDateTime(): Date | null {
        const ngbDate = this.form.get('date')?.value as NgbDate | null
        const ngbTime = this.form.get('time')?.value
        if (!ngbDate || !ngbTime) {
            return null
        }
        const date = this.ngbDateAdapter.toModel(ngbDate)
        const time = this.ngbTimeAdapter.toModel(ngbTime)
        if (!date || !time) {
            return null
        }
        return this.availability.getDateTimeForBookingSlotDateAndTime(date, time)
    }
}